import i18n from 'Lib/i18n'
import { PRODUCT_TYPES_WITHOUT_BUNDLE, I18N_PLATFORMS_NAME } from 'Types/ProductTypes'

export const CancelationReasons = [
  'Cost',
  'DifficultyOfUse',
  'CampaignPerformance',
  'Other',
] as const

function getText(reason: string) {
  return i18n.t(`plan_details.reason_modal.reasons.${reason}`, { ns: 'accountSettings' })
}

export const cancelReasons = [
  {
    label: getText(CancelationReasons[0]),
    value: CancelationReasons[0],
  },
  {
    label: getText(CancelationReasons[1]),
    value: CancelationReasons[1],
  },
  {
    label: getText(CancelationReasons[2]),
    value: CancelationReasons[2],
  },
  {
    label: getText(CancelationReasons[3]),
    value: CancelationReasons[3],
  },
]

export const PRODUCTS = Object.values(PRODUCT_TYPES_WITHOUT_BUNDLE).map((platform) => ({
  value: platform,
  label: i18n.t(I18N_PLATFORMS_NAME[platform], { ns: 'domainManagement' }),
  alert: `plan_details.reason_modal.platforms.${platform}_alert`,
}))
